module.exports = __webpack_public_path__ + "static/media/img1-6.9757c0a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/biosense/diff/img1-6.png
// module id = 1977
// module chunks = 3